export default function ({ store, redirect, route }) {
    if (!store.getters.selfserve && !store.getters.canAgent) {
        return redirect('/survey')
    }
}
